import React from 'react';
import PropTypes from 'prop-types';

const ContactUs = ({ locale }) => {
  return (
    <div
      style={{
        width: '100%',
        background:
          'linear-gradient(270deg, #1EAAE5 0%, rgba(20, 135, 184, 0.889503) 30.86%, #084F6E 100%)',
        color: 'white',
      }}
    >
      <div className="container">
        <div className="row">
          <div className="col-md-4">
            <center>
              <h4 style={{ padding: '36px 0 36px 0', margin: 0 }}>
                {locale === 'fr' ? 'CONTACTEZ-NOUS' : 'CONTACT US'}
              </h4>
            </center>
          </div>
          <div className="col-md-4">
            <center>
              <h4 style={{ margin: 0 }}>
                <i
                  style={{
                    padding: '30px 0 30px 0',
                    verticalAlign: 'middle',
                    fontSize: 40,
                  }}
                  className="material-icons"
                >
                  phone
                </i>{' '}
                <a
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                  }}
                  href="tel:+33493783534"
                >
                  04.93.78.35.34
                </a>
              </h4>
            </center>
          </div>
          <div className="col-md-4">
            <center>
              <h4 style={{ margin: 0 }}>
                <i
                  style={{
                    padding: '30px 0 30px 0',
                    verticalAlign: 'middle',
                    fontSize: 40,
                  }}
                  className="material-icons"
                >
                  mail_outline
                </i>
                <a
                  style={{
                    textDecoration: 'none',
                    color: 'inherit',
                  }}
                  href="mailto:mail@offshoreservices.fr"
                >
                  mail@offshoreservices.fr
                </a>
              </h4>
            </center>
          </div>
        </div>
      </div>
    </div>
  );
};

ContactUs.propTypes = {
  locale: PropTypes.string.isRequired,
};

export default ContactUs;



// WEBPACK FOOTER //
// ./src/components/Footer/ContactUs.js